import { FeeModel } from './../../../model/fee.model';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';
import { PaymentModel } from './../../../model/payment.model';
import { ApplicantRequestService } from './../../../service/applicant-request.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-payment-process',
  templateUrl: './payment-process.component.html',
  styleUrls: ['./payment-process.component.scss']
})
export class PaymentProcessComponent implements OnInit {
  [x: string]: any;

  constructor(private applicantRequestService: ApplicantRequestService, private route: ActivatedRoute) { }
  displayedColumns: string[] = ['fee', 'amount'];
  public totalFee: number = 0;
  public dataSource: MatTableDataSource<any>;
  applicantId: number;
  public feelist: any = [];
  public paymentType: any;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {

    this.route.params.subscribe(
      (param: Params) => {
        this.applicantId = param.referanceId;
      }
    );

    this.getRequestWorkflowStage();

  }

  getRequestWorkflowStage() {
    this.applicantRequestService.getApplicantDetails(this.applicantId).subscribe(
      (result: any) => {

        console.log(result);

        this.getPaymentDetails();
        this.paymentType = result.paySts;
      }
    );
  }

  getPaymentDetails() {
    this.applicantRequestService.paymentDetailsByApplicantId(this.applicantId).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.feelist.push(
            {fee : element.amount, description : element.description}
          );
          this.totalFee += element.amount;
        });
        this.dataSource = new MatTableDataSource(this.feelist);
      }
    );
  }


}
